import { render, staticRenderFns } from "./VerifyOTP.vue?vue&type=template&id=081f8da3&scoped=true&"
import script from "./VerifyOTP.vue?vue&type=script&lang=js&"
export * from "./VerifyOTP.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOTP.vue?vue&type=style&index=0&id=081f8da3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f8da3",
  null
  
)

export default component.exports